// extracted by mini-css-extract-plugin
module.exports = {"diskEmpty":"diskEmpty--_31ZP"};